interface RatingStarsProps {
  value: number;
  size?: "sm" | "md";
  showValue?: boolean;
}

export default function RatingStars({ value, size = "sm", showValue = true }: RatingStarsProps) {
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;
  const iconClass = size === "md" ? "text-base" : "text-xs";

  return (
    <span className="inline-flex items-center gap-0.5 text-accent-500">
      {[0, 1, 2, 3, 4].map((i) => {
        if (i < full) {
          return <span key={i} className={`flex items-center justify-center w-4 h-4 ${iconClass}`}><i className="ri-star-fill" aria-hidden="true"></i></span>;
        }
        if (i === full && hasHalf) {
          return <span key={i} className={`flex items-center justify-center w-4 h-4 ${iconClass}`}><i className="ri-star-half-fill" aria-hidden="true"></i></span>;
        }
        return <span key={i} className={`flex items-center justify-center w-4 h-4 ${iconClass} text-secondary-300`}><i className="ri-star-line" aria-hidden="true"></i></span>;
      })}
      {showValue && <span className="ml-1 text-xs text-secondary-500 font-medium">{value.toFixed(1)}</span>}
    </span>
  );
}